import { useTranslation } from "react-i18next";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import ScrollReveal from "./ScrollReveal";

const FAQSection = () => {
  const { t } = useTranslation();

  const faqs = [
    { q: t("faq.q1"), a: t("faq.a1") },
    { q: t("faq.q2"), a: t("faq.a2") },
    { q: t("faq.q3"), a: t("faq.a3") },
    { q: t("faq.q4"), a: t("faq.a4") },
    { q: t("faq.q5"), a: t("faq.a5") },
    { q: t("faq.q6"), a: t("faq.a6") },
  ];

  return (
    <section id="faq" className="py-8 lg:py-14 bg-card relative" aria-labelledby="faq-heading">
      <div className="container mx-auto px-4 max-w-3xl space-y-8">
        <ScrollReveal>
          <div className="space-y-4 text-center">
            <p className="section-label">{t("faq.label")}</p>
            <h2 id="faq-heading" className="font-display text-3xl lg:text-5xl text-foreground">{t("faq.title")}</h2>
            <p className="text-muted-foreground font-body text-base max-w-xl mx-auto">{t("faq.desc")}</p>
          </div>
        </ScrollReveal>

        <ScrollReveal>
          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((f, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="card-surface px-6 border-primary/10">
                <AccordionTrigger className="text-foreground font-body text-sm hover:no-underline py-4">{f.q}</AccordionTrigger>
                <AccordionContent className="text-muted-foreground font-body text-sm pb-4">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </ScrollReveal>
      </div>
    </section>
  );
};

export default FAQSection;
